module.exports = __webpack_public_path__ + "img/ertiga-xl7-gris-magma.8c972a8a.png";